<div class="d-flex pb-1 py-1 pb-sm-2 py-sm-2">
  <div class="flex-grow-1">
    <div class="col-12 pl-0 pr-0 myList" [ngClass]="{'text-left': leftAlign, 'text-center': !leftAlign}">
      <div class="cursor-pointer font-size-12 font-weight-semibold text-uppercase width-max-content pb-1 pr-1 mx-auto"
        [ngClass]="{'active' : selected}">
        <i class="icon-24 font-size-24 font-weight-semibold se-icon iconPosition p-0 cursor-pointer color-black">
          {{iconName}}
        </i>@if (showTitle) {
        {{title}}
      }
    </div>
  </div>
</div>
<div class="mr-0">
  <ng-content></ng-content>
</div>
</div>
